export function getDefaultRecipe(ownProps) {
  const recipes = ownProps.children;
  const defaultRecipe = recipes.find(recipe => recipe && recipe.props.isDefault);
  if (defaultRecipe) {
    return defaultRecipe;
  }
  return recipes.find(recipe => {
    const name = recipe.props.name.toLowerCase();
    return name.includes('ctrl') || name.includes('control');
  });
}
